<template>
  <div style="color:#fff" class="leftBar">
    <div class="nopx-ld-logo2">
      <img :src="imgurl2" @click="changeMaptype2" alt="" />
      <div class="ld-text">
        <p>四大古荔园、智慧</p>
        <p>荔园、五化果园</p>
      </div>
    </div>
    <v-drawer :direction="'left'" :width="'26%'">
      <div
        class="animated fadeInLeftBig data-box"
        style="height:100%;width:100%;"
      >
        <img :src="imgurl" class="nopx-ld-logo" @click="changeMaptype" alt="" />
        <div class="nopx-ld-text">
          <p>一会、一址、一馆</p>
          <p>一圃、一网、一站</p>
        </div>
        <div v-for="item in datalist" :key="item.img" class="item-box">
          <img :src="item.limg" class="jt-logo" :style="item.lbtn" alt="" />
          <img
            :src="item.img"
            @click="toshowRightDt(item)"
            class="item-logo"
            :style="item.styl"
            alt=""
          />
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
import { cyldMixin } from "@/util/mixin/cyldMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [cyldMixin],
  computed: {
    ...mapGetters(["maptype"]),
    imgurl() {
      if (this.maptype === "ly") {
        return require("@/assets/images/map/ld/liugeyi2.png");
      }
      return require("@/assets/images/map/ld/liugeyi.png");
    },
    imgurl2() {
      if (this.maptype === "gy") {
        return require("@/assets/images/map/ld/liugey2.png");
      }
      return require("@/assets/images/map/ld/liugey.png");
    }
  },
  data() {
    return {
      datalist: [
        {
          name: "中国荔枝产业大会",
          img: require("@/assets/images/map/ld/l-01.png"),
          limg: require("@/assets/images/map/ld/7.png"),
          lbtn: "bottom:25%;right: 3%;",
          styl: "right:23%"
        },
        {
          name: "中国荔枝产业大会会址",
          img: require("@/assets/images/map/ld/l-02.png"),
          limg: require("@/assets/images/map/ld/8.png"),
          lbtn: "bottom:5%;right: 8%;",
          styl: "right:45%"
        },
        {
          //   name: "中国荔枝博物馆",
          name: "中国荔枝博览馆",
          img: require("@/assets/images/map/ld/l-03.png"),
          limg: require("@/assets/images/map/ld/9.png"),
          lbtn: "bottom:6%;right: 12%;",
          styl: "right:49%",
          url: "http://zglzblg.com/vr"
        },
        {
          name: "国家荔枝种质资源圃",
          img: require("@/assets/images/map/ld/l-04.png"),
          limg: require("@/assets/images/map/ld/10.png"),
          lbtn: "bottom:47%;right: 14%;",
          styl: "right:49%"
        },
        {
          name: "广东茂名荔枝大数据平台",
          img: require("@/assets/images/map/ld/l-05.png"),
          limg: require("@/assets/images/map/ld/11.png"),
          lbtn: "bottom:48%;right: 9%;",
          styl: "right:45%"
        },
        {
          name: "田头小站",
          img: require("@/assets/images/map/ld/l-06.png"),
          limg: require("@/assets/images/map/ld/12.png"),
          lbtn: "bottom:47%;right: -10%;",
          styl: "right:23%"
        }
      ]
    };
  },
  mounted() {
    this.t61List = [];
    this.getdata();
  },
  methods: {
    changeMaptype() {
      if (this.maptype !== "ly") {
        this.$store.dispatch("map/setLdMaptype", "ly");
      }
    },
    changeMaptype2() {
      if (this.maptype !== "gy") {
        this.$store.dispatch("map/setLdMaptype", "gy");
      }
    },
    toshowRightDt(it) {
      const name = it.name;
      let index = findIndexByName(name, this.t61List);
      if (index === -1) {
        return;
      }

      get("/api/restful/findByIds?id=" + this.t61List[index].id).then(res => {
        if (res.websiteNewsFiles instanceof Array) {
          this.showRightDt(
            Object.assign({ url: it.url || "" }, this.t61List[index], {
              orgCompanyFiles: res.websiteNewsFiles
            })
          );
        } else {
          this.showRightDt(
            Object.assign({ url: it.url || "" }, this.t61List[index], {
              orgCompanyFiles: []
            })
          );
        }
      });
    },
    getdata() {
      get("/api/restful/findBySubjectPidSimple", {
        websiteBaseSubjectId: "0b2f7cd76424437f8488073947bc0973"
      }).then(res => {
        this.t61List = res.content.map(e => {
          return {
            id: e.id,
            name: e.name,
            qyjs: e.detail,
            orgCompanyFiles: [{ address: e.pic }]
          };
        });
        // 共享数据给rightbar
        sessionStorage.setItem("lgyData", JSON.stringify(this.t61List));
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.nopx-ld-logo2
    position absolute
    top calc(46% - 30px)
    right calc(26% + 4px)
    cursor pointer
    z-index 8
    .ld-text
        color white
        margin-top 4px
        line-height 1.4
.data-box
    display flex
    position relative
    flex-direction column
    .nopx-ld-text
        position absolute
        top calc(50% + 50px)
        right -92px
        color white
    .nopx-ld-logo
        position absolute
        top calc(46% - 75px)
        right -88px
        cursor pointer
    .item-box
        position relative
        flex 1
        .jt-logo
            position absolute
            transform: rotateY(180deg)
        .item-logo
            position absolute
            cursor pointer

@media (max-height 950px)
    .leftBar
        >>>
            .data-box
                .item-box
                    .item-logo
                        height 90%
</style>
